import { createRouter, createWebHistory } from 'vue-router'
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import routes from './routes'

const router = createRouter({
  routes,
  history: createWebHistory(),
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // If this isn't an initial page load...
  if (routeFrom.name) {
    // Start the route progress bar.
    NProgress.start()
  }

  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

  // If auth isn't required for the route, just continue.
  if (!authRequired) return next()

  // Validate the local user token...
  return store
    .dispatch('auth/validate')
    .then((validUser) => {
      // Then continue if the token still represents a valid user,
      // otherwise redirect to login.
      if (validUser) {
        next()
        store.dispatch('contentBlocks/fetchAll')
      } else {
        store.dispatch('auth/logIn', { routeTo })
      }
    })
    .catch((error) => {
      next({ name: 'error', query: { message: error.errorDescription } })
    })
})

// When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
